"use client"

import { useState, useEffect, useContext } from "react"
import { ErpContext } from "../../../context/ErpContext.js"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Grid,
  Paper,
  Tabs,
  Tab,
  Divider,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  alpha,
  useTheme,
  Card,
  CardContent,
  Button,
  CircularProgress,
  Tooltip,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet"
import ReceiptIcon from "@mui/icons-material/Receipt"
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart"
import PersonIcon from "@mui/icons-material/Person"
import BusinessIcon from "@mui/icons-material/Business"
import TrendingUpIcon from "@mui/icons-material/TrendingUp"
import BalanceIcon from "@mui/icons-material/Balance"
import DownloadIcon from "@mui/icons-material/Download"
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"
import PaymentIcon from "@mui/icons-material/Payment"
import AttachMoneyIcon from "@mui/icons-material/AttachMoney"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import PendingIcon from "@mui/icons-material/Pending"
import GroupIcon from "@mui/icons-material/Group"
import LocationOnIcon from "@mui/icons-material/LocationOn"
import UndoIcon from "@mui/icons-material/Undo"
import WarningIcon from "@mui/icons-material/Warning"
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  Legend,
  ResponsiveContainer,
  LineChart,
  Line,
} from "recharts"
import jsPDF from "jspdf"
import "jspdf-autotable"
import { deliverPdf, reservePdfTarget } from "../../../context/pdf_esqueletos/helpers/pdfDelivery.js"
import ModalMedioDePago from "../ModalMedioDePago"
import { generateReceiptPDF, generateRefundReceiptPDF } from "../../../context/pdf_esqueletos/reciboFacturaCuotaPdf.js"
import ModalOpcionesFactura from "../ModalFacturaComponent.js"
import { generarPdfClientePaqueteMovimientos } from "../../../context/pdf_esqueletos/clientePaqueteMovimientosPdf.js"

const ModalDetalleCuentaCorriente = ({ open, handleClose, cuentaCorriente }) => {
  const theme = useTheme()
  const {
    getCuentaCorrienteCuotas,
    getClientePaqueteMovimientos,
    updateCuentaCorrienteCuota,
    revertirPagoCuota,
    postTransaccion,
    postCrearPago,
    postTransaccionPago,
    getParametrosGlobales,
    user,
  } = useContext(ErpContext)
  const [, setTransaccionesData] = useState([])
  const [, setTransaccionesStats] = useState({
    totalCompras: 0,
    totalPagos: 0,
    ultimaTransaccion: null,
  })
  const [logoTenant, setLogoTenant] = useState(null)
  const [showFechaViajePdf, setShowFechaViajePdf] = useState(true)

  useEffect(() => {
    let cancelado = false

    if (!open) {
      setLogoTenant(null)
      setShowFechaViajePdf(true)
      setTabActivaDetalle("cuotas")
      return
    }

    ;(async () => {
      try {
        const params = await getParametrosGlobales([
          'logoNavbarTenant',
          'idUbicacionDefaultTransaccionCaja',
          'verFechaSalidaYFechaFinPdf',
          'verFechaSalidaPdf',
        ])
        const fechaViajePdfConfig =
          params?.verFechaSalidaYFechaFinPdf ?? params?.verFechaSalidaPdf
        if (cancelado) return
        setLogoTenant(params?.logoNavbarTenant || null)
        setIdUbicacionDefaultTransaccionCaja(params?.idUbicacionDefaultTransaccionCaja || null)
        setShowFechaViajePdf(
          fechaViajePdfConfig === 1 ||
          fechaViajePdfConfig === "1" ||
          fechaViajePdfConfig === true ||
          fechaViajePdfConfig === "true"
        )
      } catch (error) {
        if (!cancelado) {
          console.error("Error cargando parámetros del tenant:", error)
          setLogoTenant(null)
          setIdUbicacionDefaultTransaccionCaja(null)
          setShowFechaViajePdf(true)
        }
      }
    })()

    return () => {
      cancelado = true
    }
  }, [open, getParametrosGlobales])
  // Estados para cuotas
  const [cuotasData, setCuotasData] = useState([])
  const [historialData, setHistorialData] = useState([])
  const [loadingCuotas, setLoadingCuotas] = useState(false)
  const [loadingHistorial, setLoadingHistorial] = useState(false)
  const [generatingHistorialPdf, setGeneratingHistorialPdf] = useState(false)
  const [tabActivaDetalle, setTabActivaDetalle] = useState("cuotas")
  const [cuotasInfo, setCuotasInfo] = useState({
    total: 0,
    totalOriginal: 0,
    totalPagado: 0,
    totalPendiente: 0,
    totalIntereses: 0,
    totalDevoluciones: 0,
    pagadas: 0,
    pendientes: 0,
    item: null,
    ubicacion: null,
    liberado: false,
  })
  // Estados para pago de cuotas
  const [abrirModalPagoCuota, setAbrirModalPagoCuota] = useState(false)
  const [cuotaSeleccionada, setCuotaSeleccionada] = useState(null)
  // Estados para modal de confirmación de pago
  const [modalConfirmacionPagoOpen, setModalConfirmacionPagoOpen] = useState(false)
  const [datosUltimoPago, setDatosUltimoPago] = useState(null)
  // Estados para revertir pago
  const [modalConfirmacionRevertirOpen, setModalConfirmacionRevertirOpen] = useState(false)
  const [cuotaARevertir, setCuotaARevertir] = useState(null)
  const [modalMediosDePagoRevertirOpen, setModalMediosDePagoRevertirOpen] = useState(false)
  const [modalReversionExitosaOpen, setModalReversionExitosaOpen] = useState(false)
  const [datosReversion, setDatosReversion] = useState(null)
  const [idUbicacionDefaultTransaccionCaja, setIdUbicacionDefaultTransaccionCaja] = useState(null)

  // Procesar datos cuando cambia la cuenta corriente seleccionada
  useEffect(() => {
    if (cuentaCorriente) {
      // Procesar transacciones
      const transacciones = Array.isArray(cuentaCorriente.transacciones) ? cuentaCorriente.transacciones : []
      const transaccionesItems = Array.isArray(cuentaCorriente.transaccionesItems)
        ? cuentaCorriente.transaccionesItems
        : []

      // Extraer todos los items de todas las transacciones
      const allItems = []
      transaccionesItems.forEach((tx) => {
        if (Array.isArray(tx.TransaccionItems)) {
          tx.TransaccionItems.forEach((item) => {
            if (item.item) {
              allItems.push({
                id: item.idItem,
                descripcion: item.item.descripcion || "Sin descripción",
                cantidad: item.cantidad || 0,
                precio: item.precio || 0,
                montoTotal: item.montoTotal || 0,
                fecha: tx.fechaHoraCreacion,
                idTransaccion: tx.id,
              })
            }
          })
        }
      })

      // Calcular estadísticas
      // Clasificar transacciones según operacionParaCuentaCorriente
      const transaccionesQueGeneranDeuda = transacciones.filter(
        (t) => t.operacionParaCuentaCorriente !== 'operacionCaja'
      )
      const transaccionesQueSaldanDeuda = transacciones.filter(
        (t) => t.operacionParaCuentaCorriente === 'operacionCaja'
      )
      const totalCompras = transaccionesQueGeneranDeuda.reduce((sum, t) => sum + Math.abs(t.montoTotal || 0), 0)
      const totalPagos = transaccionesQueSaldanDeuda.reduce((sum, t) => sum + Math.abs(t.montoTotal || 0), 0)

      // Ordenar transacciones por fecha (más reciente primero) con parseo seguro
      const sortedTransacciones = [...transacciones].sort((a, b) => {
        const db = parseDateSafe(b.fecha)?.getTime() || 0
        const da = parseDateSafe(a.fecha)?.getTime() || 0
        return db - da
      })

      setTransaccionesData(sortedTransacciones)
      setTransaccionesStats({
        totalCompras,
        totalPagos,
        ultimaTransaccion: sortedTransacciones[0] || null,
      })

      // Cargar cuotas si tenemos los datos necesarios
      console.log('🔎 Datos de cuentaCorriente:', {
        idEntidad: cuentaCorriente.idEntidad,
        idItem: cuentaCorriente.idItem,
        idUbicacion: cuentaCorriente.idUbicacion,
        completo: cuentaCorriente
      })
      if (cuentaCorriente.idEntidad && cuentaCorriente.idItem && cuentaCorriente.idUbicacion) {
        loadCuotas(cuentaCorriente.idEntidad, cuentaCorriente.idItem, cuentaCorriente.idUbicacion)
        loadHistorial(cuentaCorriente.idEntidad, cuentaCorriente.idItem, cuentaCorriente.idUbicacion)
      } else {
        console.warn('⚠️ Faltan datos para cargar cuotas')
        setHistorialData([])
      }
    }
  }, [cuentaCorriente])

  // Función para cargar las cuotas
  const loadCuotas = async (idEntidad, idItem, idUbicacion) => {
    try {
      setLoadingCuotas(true)
      const response = await getCuentaCorrienteCuotas(idEntidad, idItem, idUbicacion)
      setCuotasData(response.cuotas || [])
      setCuotasInfo({
        total: response.total || 0,
        totalOriginal: response.totalOriginal || 0,
        totalPagado: response.totalPagado || 0,
        totalPendiente: response.totalPendiente || 0,
        totalIntereses: response.totalIntereses || 0,
        totalDevoluciones: response.totalDevoluciones || 0,
        pagadas: response.pagadas || 0,
        pendientes: response.pendientes || 0,
        item: response.item || null,
        ubicacion: response.ubicacion || null,
        paquete: response.paquete || null,
        liberado: response.liberado || false, // 🆕 Flag para detectar pasajeros liberados
      })
    } catch (error) {
      console.error("Error cargando cuotas:", error)
      setCuotasData([])
      setCuotasInfo({
        total: 0,
        totalOriginal: 0,
        totalPagado: 0,
        totalPendiente: 0,
        totalIntereses: 0,
        totalDevoluciones: 0,
        pagadas: 0,
        pendientes: 0,
        item: null,
        ubicacion: null,
        paquete: null,
        liberado: false,
      })
    } finally {
      setLoadingCuotas(false)
    }
  }

  const loadHistorial = async (idEntidad, idItem, idUbicacion) => {
    try {
      setLoadingHistorial(true)
      const response = await getClientePaqueteMovimientos({
        page: 1,
        limit: 5000,
        idEntidad,
        idItem,
        idUbicacion,
      })
      setHistorialData(Array.isArray(response?.data) ? response.data : [])
    } catch (error) {
      console.error("Error cargando historial de cuotas:", error)
      setHistorialData([])
    } finally {
      setLoadingHistorial(false)
    }
  }

  // Abrir modal de pago para una cuota
  const handleOpenPagoCuota = (cuota) => {
    setCuotaSeleccionada(cuota)
    setAbrirModalPagoCuota(true)
  }

  // Cerrar modal de pago
  const handleClosePagoCuota = () => {
    setAbrirModalPagoCuota(false)
    setCuotaSeleccionada(null)
  }

  // Abrir modal de confirmación para revertir
  const handleOpenRevertirPago = (cuota) => {
    setCuotaARevertir(cuota)
    setModalConfirmacionRevertirOpen(true)
  }

  // Cerrar modal de confirmación de reversión
  const handleCloseConfirmacionRevertir = () => {
    setModalConfirmacionRevertirOpen(false)
    setCuotaARevertir(null)
  }

  // Confirmar reversión de pago (abre modal de medios de pago)
  const handleConfirmarReversion = () => {
    if (!cuotaARevertir) {
      console.error("No hay cuota seleccionada para revertir")
      return
    }

    // Cerrar solo el modal de confirmación (NO limpiar cuotaARevertir, se necesita para el modal de medios de pago)
    setModalConfirmacionRevertirOpen(false)

    // Abrir modal de medios de pago
    setModalMediosDePagoRevertirOpen(true)
  }

  // Cerrar modal de medios de pago para reversión (y limpiar cuotaARevertir)
  const handleCloseModalMediosDePagoRevertir = () => {
    setModalMediosDePagoRevertirOpen(false)
    setCuotaARevertir(null)
  }

  // Confirmar reversión con medios de pago seleccionados
  const handleConfirmarReversionConMediosDePago = async (mediosDePago) => {
    try {
      if (!cuotaARevertir) {
        console.error("No hay cuota seleccionada para revertir")
        return
      }

      // Calcular monto total a devolver
      const montoTotalDevolver = mediosDePago.reduce((sum, mp) => sum + (Number(mp.monto) || 0), 0)

      // Llamar al backend con los medios de pago
      const response = await revertirPagoCuota(
        cuotaARevertir.cuotaNro,
        cuotaARevertir.idEntidad,
        cuotaARevertir.idItem,
        cuotaARevertir.idUbicacion,
        mediosDePago,
        montoTotalDevolver
      )

      // Cerrar modal de medios de pago y limpiar cuotaARevertir
      handleCloseModalMediosDePagoRevertir()

      // Recargar cuotas
      if (cuentaCorriente.idEntidad && cuentaCorriente.idItem && cuentaCorriente.idUbicacion) {
        await loadCuotas(cuentaCorriente.idEntidad, cuentaCorriente.idItem, cuentaCorriente.idUbicacion)
        await loadHistorial(cuentaCorriente.idEntidad, cuentaCorriente.idItem, cuentaCorriente.idUbicacion)
      }

      // Abrir modal de reversión exitosa con los datos
      setDatosReversion({
        ...response.datosReversion,
        cuota: cuotaARevertir
      })
      setModalReversionExitosaOpen(true)
    } catch (error) {
      console.error("❌ Error al revertir pago de cuota:", error)
      alert("Error al revertir el pago: " + (error.response?.data?.message || error.message))
    }
  }

  // Confirmar pago de cuota
  const handleConfirmarPagoCuota = async (mediosDePago, montoTotalMediosPago, transaccionSeleccionada, descripcion, idUbicacionSeleccionada) => {
    try {
      if (!cuotaSeleccionada) {
        console.error("No hay cuota seleccionada")
        return
      }

      const esRepago = cuotaSeleccionada.esRepago === true
      const descripcionFinal = descripcion || (esRepago
        ? `Re-pago de cuota ${cuotaSeleccionada.cuotaNro}`
        : `Pago de cuota ${cuotaSeleccionada.cuotaNro}`)

      // Para re-pago: transaccionAsociada apunta a la última devolución
      const transaccionAsociadaPago = esRepago ? (cuotaSeleccionada.devolucionTransaccionId || null) : null

      // 1. Crear transacción de tipo 1 (Venta - pago de cuota)
      const transaccionResponse = await postTransaccion(
        montoTotalMediosPago, // Monto total de la transacción
        1, // Tipo 1 = Venta (pago de cuota)
        cuentaCorriente.idEntidad, // idEntidad
        null, // no es necesario enviar subcategoría
        descripcionFinal,
        user.id,
        idUbicacionSeleccionada || 1, // ubicación seleccionada desde el modal
        1, // negocio central
        0, // descuento
        0, // porcentaje descuento
        transaccionAsociadaPago, // transaccionAsociada: para re-pago apunta a la devolución
        null, // fecha
        false // NO afecta cuenta corriente general
      )

      const idTransaccion = transaccionResponse.data.id

      // 2. Crear pagos por cada medio de pago
      for (const medioPago of mediosDePago) {
        const pagoCreado = await postCrearPago(
          1, // Moneda por default 1 que es peso hardcoded
          1, // cotización
          medioPago.id, // Medio de pago id
          medioPago.monto
        )
        const idPago = pagoCreado.data.id

        // 3. Vincular pago a transacción
        await postTransaccionPago(idTransaccion, idPago)
      }

      // 4. Actualizar la cuota con el idTransaccion
      await updateCuentaCorrienteCuota(
        cuotaSeleccionada.cuotaNro,
        cuotaSeleccionada.idEntidad,
        cuotaSeleccionada.idItem,
        cuotaSeleccionada.idUbicacion,
        idTransaccion
      )

      // 5. Recargar cuotas
      if (cuentaCorriente.idEntidad && cuentaCorriente.idItem && cuentaCorriente.idUbicacion) {
        await loadCuotas(cuentaCorriente.idEntidad, cuentaCorriente.idItem, cuentaCorriente.idUbicacion)
        await loadHistorial(cuentaCorriente.idEntidad, cuentaCorriente.idItem, cuentaCorriente.idUbicacion)
      }

      // 6. Cerrar modal de medio de pago y abrir modal de confirmación
      handleClosePagoCuota()
      setDatosUltimoPago({
        idTransaccion,
        cuota: {
          ...cuotaSeleccionada,
          montoPagado: montoTotalMediosPago  // Agregar el monto pagado al objeto cuota
        },
        monto: montoTotalMediosPago
      })
      setModalConfirmacionPagoOpen(true)
    } catch (error) {
      console.error("❌ Error al procesar pago de cuota:", error)
      alert("Error al procesar el pago: " + error.message)
    }
  }

  // Formatear moneda
  const formatCurrency = (value) => {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS",
      maximumFractionDigits: 0,
    }).format(value)
  }

  // ✅ Parseo de fecha evitando desfase por UTC (patrón de ClienteCuotasDetalle.js)
  // Para fechas YYYY-MM-DD desde la base, parseamos explícitamente en hora local
  // en lugar de usar new Date("2025-02-20") que interpreta como medianoche UTC
  const parseDateSafe = (value) => {
    if (!value) return null
    
    // Si ya es un Date válido, retornarlo
    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : value
    }
    
    if (typeof value === "string") {
      // ✅ CLAVE: Para fechas YYYY-MM-DD (o ISO con hora), extraer año/mes/día
      // y crear Date en hora local para evitar desfase de timezone
      const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/)
      if (match) {
        const [, year, month, day] = match
        // new Date(year, month-1, day) crea la fecha a medianoche LOCAL
        // evitando el problema de new Date("2025-02-20") que es medianoche UTC
        return new Date(Number(year), Number(month) - 1, Number(day))
      }
      
      // Fallback: formato DD/MM/YYYY
      const parts = value.split("/")
      if (parts.length === 3) {
        const [dd, mm, yyyy] = parts
        return new Date(Number(yyyy), Number(mm) - 1, Number(dd))
      }
    }
    
    // Último recurso: parsear como Date genérico
    const d = new Date(value)
    return isNaN(d.getTime()) ? null : d
  }

  // Formatear fecha con tolerancia a formatos inválidos
  const formatDate = (dateString) => {
    if (!dateString) return "N/A"
    const dateObj = parseDateSafe(dateString)
    if (!dateObj) return String(dateString)
    return new Intl.DateTimeFormat("es-AR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(dateObj)
  }

  // Calcular importe a pagar según 2do vencimiento
  const getMontoBaseNeto = (cuota) => {
    const baseBruta = Number(cuota?.montoBase ?? cuota?.monto ?? 0) || 0
    const descuento = Number(cuota?.montoDescuento ?? 0) || 0
    return Math.max(0, baseBruta - descuento)
  }

  const getImporteAPagar = (cuota) => {
    const base = getMontoBaseNeto(cuota)
    const interes = Number(cuota?.montoInteres ?? 0) || 0
    const vto2 = parseDateSafe(cuota?.fechaSegundoVto)
    const hoy = new Date()
    if (vto2 && hoy > vto2) {
      return base + interes
    }
    return base
  }

  const getInteresVisible = (cuota) => {
    const interes = Number(cuota?.montoInteres ?? 0) || 0
    const vto2 = parseDateSafe(cuota?.fechaSegundoVto)
    const hoy = new Date()
    if (interes > 0 && vto2 && hoy > vto2) return interes
    return null
  }

  const getCuotaByNumero = (cuotaNro) =>
    (cuotasData || []).find((cuota) => Number(cuota.cuotaNro) === Number(cuotaNro)) || null

  const handleDescargarPdfHistorial = (row) => {
    const cuota = getCuotaByNumero(row?.cuotaNro)
    if (!cuota) {
      console.error("No se encontró la cuota asociada para PDF de historial", row)
      return
    }

    if (row?.tipo === "reversion") {
      const datosReversion = {
        montoRevertido: Number(cuota.montoDevolucion || 0),
        fechaPagoOriginal: cuota.transaccion?.fecha,
        fechaReversion: cuota.devolucionFecha || new Date(),
      }
      // Misma lógica que en tab Cuotas para devolución
      generateRefundReceiptPDF(cuota, datosReversion, cuentaCorriente, cuotasInfo, false, logoTenant, null, showFechaViajePdf)
      return
    }

    // Misma lógica que en tab Cuotas para pago
    generateReceiptPDF(cuota, cuota.transaccion, cuentaCorriente, cuotasInfo, false, logoTenant, null, showFechaViajePdf)
  }

  const handleExportarHistorialPdfGeneral = async () => {
    try {
      setGeneratingHistorialPdf(true)
      generarPdfClientePaqueteMovimientos({
        movimientos: historialData || [],
        filtros: {
          fechaDesde: null,
          fechaHasta: null,
        },
        usuario: user?.nombre || user?.usuario || "Usuario",
        logoBase64: logoTenant || null,
        deliveryContext: { targetWindow: reservePdfTarget() },
      })
    } catch (error) {
      console.error("Error generando PDF general de historial:", error)
    } finally {
      setGeneratingHistorialPdf(false)
    }
  }

 // Función para generar PDF con el formato de la imagen de referencia
 const handleDownloadTransaction = (transaction) => {
  const deliveryContext = { targetWindow: reservePdfTarget() }
  const doc = new jsPDF({ unit: "pt", format: "a4", orientation: "portrait" })

  const totalPlanOriginal = Number(cuentaCorriente?.precioOriginal ?? cuotasInfo.paquete?.monto ?? cuotasInfo.totalOriginal ?? 0) || 0
  const totalCuotasPagadasValue = Number(cuotasInfo.totalPagado || 0)
  const saldoCuotasPendiente = Number(cuotasInfo.totalPendiente || 0)
  const cuotasPagadasCount = Number(cuotasInfo.pagadas || 0)
  const cuotasRevertidasCount = (cuotasData || []).filter(
    (c) => c.idTransaccion !== null && Number(c.montoDevolucion || 0) > 0
  ).length
  const cuotasPendientesCount =
    Number(cuotasInfo.pendientes || 0) + cuotasRevertidasCount
  const totalCuotasCount = (cuotasData || []).length || 0

  const totalConDescuento = Number(cuentaCorriente?.precioOriginal ?? cuotasInfo.totalOriginal ?? cuotasInfo.total ?? 0) || 0

  const ultimaFechaPago = (cuotasData || []).reduce((acc, cuota) => {
    const fecha = cuota?.transaccion?.fecha
    const d = parseDateSafe(fecha)
    if (!d) return acc
    if (!acc || d > acc) return d
    return acc
  }, null)

  // ======= Tokens de diseño =======
  const PAL = {
    primary: [25, 118, 210],
    ink: [33, 33, 33],
    muted: [117, 117, 117],
    inkLight: [158, 158, 158],
  }
  const M = { l: 48, r: 48, t: 48, b: 48, gridGap: 16 }

  const text = (str, x, y, { size = 10, color = PAL.ink, align = "left", bold = false } = {}) => {
    doc.setFont("helvetica", bold ? "bold" : "normal")
    doc.setFontSize(size)
    doc.setTextColor(...color)
    doc.text(str, x, y, { align })
  }

  const getImageFormat = (dataUrl) => {
    const match = /^data:image\/(png|jpe?g|webp);/i.exec(dataUrl || "")
    if (!match) return "PNG"
    const ext = match[1].toLowerCase()
    if (ext === "jpg" || ext === "jpeg") return "JPEG"
    if (ext === "webp") return "WEBP"
    return "PNG"
  }

  const sectionTitleColumn = (label, x, y, width) => {
    doc.setDrawColor(...PAL.primary)
    doc.setLineWidth(1)
    doc.line(x, y + 6, x + width, y + 6)
    text(label, x, y, { size: 11, color: PAL.primary, bold: true })
  }

  const formatDateOrDash = (value) => (value ? formatDate(value) : "-")

  const kvRow = (label, value) => ([
    { content: label, styles: { halign: "left", fontStyle: "bold", textColor: PAL.muted } },
    { content: value ?? "-", styles: { halign: "left" } }
  ])

  const pageW = doc.internal.pageSize.getWidth()

  // ======= Header =======
  if (logoTenant) {
    try {
      const logoMaxW = 90
      const logoMaxH = 42
      const props = doc.getImageProperties(logoTenant)
      const ratio = Math.min(logoMaxW / props.width, logoMaxH / props.height)
      const logoW = props.width * ratio
      const logoH = props.height * ratio
      doc.addImage(logoTenant, getImageFormat(logoTenant), M.l, 14, logoW, logoH)
    } catch (error) {
      // Ignorar errores de logo para no bloquear el PDF
    }
  }

  text("DETALLE DE TRANSACCIÓN", pageW / 2, 32, {
    size: 16, color: PAL.primary, align: "center", bold: true
  })
  text(`Fecha de emisión: ${new Date().toLocaleDateString("es-AR")}`, pageW - M.r, 48, {
    size: 9, color: PAL.inkLight, align: "right"
  })

  // Grupo / Destino
  const grupoText = cuotasInfo.item?.descripcion || "-"
  const destinoText = cuotasInfo.ubicacion?.descripcion || "-"
  text(`Grupo: ${grupoText}`, M.l, 70, { size: 10, color: PAL.ink, bold: true })
  text(`Destino: ${destinoText}`, M.l + 220, 70, { size: 10, color: PAL.ink, bold: true })

  // ======= Secciones (2 columnas) =======
  const colWidth = (pageW - M.l - M.r - M.gridGap) / 2
  let cursorY = 100

  sectionTitleColumn("INFORMACIÓN DEL CLIENTE", M.l, cursorY, colWidth)
  sectionTitleColumn("ESTADO DE CUOTAS", M.l + colWidth + M.gridGap, cursorY, colWidth)
  cursorY += 18

  doc.autoTable({
    startY: cursorY,
    margin: { left: M.l, right: pageW - (M.l + colWidth) },
    theme: "plain",
    styles: { font: "helvetica", fontSize: 9.5, cellPadding: 3, textColor: PAL.ink },
    columnStyles: { 0: { cellWidth: 110 }, 1: { cellWidth: colWidth - 110 } },
    body: [
      kvRow("Nombre", `${cuentaCorriente.entidadCompleta?.descripcion || "-"} ${cuentaCorriente.entidadCompleta?.apellido || ""}`.trim()),
      kvRow("DNI/CUIT/CUIL", cuentaCorriente.entidadCompleta?.dniCuitCuil || "-"),
      kvRow("Teléfono", cuentaCorriente.entidadCompleta?.telefono || "-"),
      kvRow("Email", cuentaCorriente.entidadCompleta?.email || "-"),
      kvRow("Tipo de Entidad", cuentaCorriente.tipoEntidad || "-"),
    ],
  })

  const rightStartX = M.l + colWidth + M.gridGap
  const saldoColor = saldoCuotasPendiente <= 0 ? [76, 175, 80] : [230, 126, 34]
  doc.autoTable({
    startY: cursorY,
    margin: { left: rightStartX, right: M.r },
    theme: "plain",
    styles: { font: "helvetica", fontSize: 9.5, cellPadding: 3, textColor: PAL.ink },
    columnStyles: { 0: { cellWidth: 140 }, 1: { cellWidth: colWidth - 140 } },
    body: [
      kvRow("Total original del plan", formatCurrency(totalPlanOriginal)),
      kvRow("Total con Descuento", formatCurrency(totalConDescuento)),
      kvRow("Total cuotas pagadas", formatCurrency(totalCuotasPagadasValue)),
      kvRow("Saldo a pagar", ""), // valor en naranja
      kvRow("Cuotas pagadas", `${cuotasPagadasCount} de ${totalCuotasCount}`),
      kvRow("Cuotas pendientes", `${cuotasPendientesCount} de ${totalCuotasCount}`),
      kvRow("Fecha de Pago", ultimaFechaPago ? formatDateOrDash(ultimaFechaPago) : "-"),
    ],
    didDrawCell: (data) => {
      if (data.section === "body" && data.row.index === 3 && data.column.index === 1) {
        doc.setFont("helvetica", "bold")
        doc.setFontSize(9.5)
        doc.setTextColor(...saldoColor)
        const saldoText = formatCurrency(saldoCuotasPendiente)
        doc.text(saldoText, data.cell.x + 2, data.cell.y + data.cell.height / 2 + 3, { align: "left" })
        doc.setTextColor(...PAL.ink)
        doc.setFont("helvetica", "normal")
      }
    },
  })

  cursorY = Math.max(doc.lastAutoTable.finalY, cursorY) + 22

  // ======= Detalle de la Transacción =======
  doc.setDrawColor(...PAL.primary)
  doc.setLineWidth(1)
  doc.line(M.l, cursorY + 6, pageW - M.r, cursorY + 6)
  text("DETALLE DE LA TRANSACCIÓN", M.l, cursorY, { size: 11, color: PAL.primary, bold: true })
  cursorY += 18

  const cuotasRows = []
  for (const cuota of cuotasData || []) {
    const montoDevolucion = Number(cuota.montoDevolucion || 0)
    const estaRevertida = cuota.idTransaccion !== null && montoDevolucion > 0
    const estaPagada = cuota.idTransaccion !== null && montoDevolucion === 0
    const estaPendiente = cuota.idTransaccion === null

    const estado = estaRevertida ? "Pendiente" : estaPagada ? "Pagada" : "Pendiente"
    // Cuota revertida: importe = monto de la cuota ($17k). La fila Dev. muestra lo devuelto ($7k)
    const importeActual = estaRevertida
      ? Number(cuota.montoPagado ?? cuota.monto ?? getMontoBaseNeto(cuota) ?? 0) || 0
      : estaPagada
        ? Number(cuota.montoPagado ?? cuota.monto ?? getMontoBaseNeto(cuota) ?? 0) || 0
        : getImporteAPagar(cuota)
    const fechaPago = estaPagada
      ? formatDateOrDash(cuota.transaccion?.fecha)
      : "-"

    cuotasRows.push([
      `#${String(cuota.cuotaNro).padStart(2, "0")}`,
      formatDateOrDash(cuota.fechaPrimerVto),
      formatDateOrDash(cuota.fechaSegundoVto),
      estado,
      formatCurrency(importeActual),
      fechaPago,
    ])

    if (estaRevertida) {
      cuotasRows.push([
        `Dev. #${String(cuota.cuotaNro).padStart(2, "0")}`,
        "-",
        "-",
        "Devolución",
        formatCurrency(montoDevolucion),
        formatDateOrDash(cuota.devolucionFecha),
      ])
    }
  }

  const tableSideMargin = 10
  const tableWidth = pageW - tableSideMargin * 2
  const fixedWidth = 70 + 90 + 90 + 90 + 110
  const lastColWidth = Math.max(110, tableWidth - fixedWidth)

  doc.autoTable({
    startY: cursorY,
    margin: { left: tableSideMargin, right: tableSideMargin },
    tableWidth,
    theme: "striped",
    head: [["Cuota", "1er Vto", "2do Vto", "Estado", "Importe actual", "Pago/Fecha"]],
    body: cuotasRows,
    styles: { font: "helvetica", fontSize: 9, cellPadding: 4 },
    headStyles: { fillColor: PAL.primary, textColor: [255, 255, 255] },
    columnStyles: {
      0: { cellWidth: 70 },
      1: { cellWidth: 90 },
      2: { cellWidth: 90 },
      3: { cellWidth: 90 },
      4: { cellWidth: 110, halign: "right" },
      5: { cellWidth: lastColWidth },
    },
  })

  const fileName = `transaccion_${transaction?.id || "s/n"}_${cuentaCorriente?.entidadCompleta?.dniCuitCuil || "cliente"}_${new Date().toISOString().slice(0,10)}.pdf` 
  doc.setProperties({ title: fileName, subject: "Detalle de Transacción", creator: "Sistema" })
  deliverPdf({ doc, fileName, targetWindow: deliveryContext.targetWindow })
}

  const saldoPendiente = Number(cuotasInfo.totalPendiente || 0)
  const saldoChipBg =
    saldoPendiente === 0
      ? alpha(theme.palette.success.main, 0.1)
      : alpha(theme.palette.warning.main, 0.1)
  const saldoChipColor =
    saldoPendiente === 0
      ? theme.palette.success.main
      : theme.palette.warning.main
  const saldoChipIcon =
    saldoPendiente === 0 ? (
      <BalanceIcon fontSize="small" />
    ) : (
      <TrendingUpIcon fontSize="small" />
    )
  const totalCuotasPagadas = Number(cuotasInfo.totalPagado || 0)

  if (!cuentaCorriente) return null

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2, bgcolor: theme.palette.primary.main, color: "white" }}>
        Detalle de cuotas
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "white",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        {/* Alerta de paquete cancelado */}
        {cuentaCorriente?.paqueteCancelado === true && (
          <Box sx={{ mb: 3 }}>
            <Paper
              elevation={3}
              sx={{
                p: 2,
                backgroundColor: alpha(theme.palette.error.main, 0.1),
                borderLeft: `4px solid ${theme.palette.error.main}`,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <WarningIcon sx={{ color: theme.palette.error.main, fontSize: 28 }} />
                <Box>
                  <Typography variant="h6" sx={{ color: theme.palette.error.main, fontWeight: 700 }}>
                    VIAJE CANCELADO
                  </Typography>
                  <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                    Este paquete fue cancelado. No se pueden realizar nuevos pagos de cuotas. Solo es posible revertir cuotas ya pagadas.
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Box>
        )}
        {/* Información del cliente */}
        <Box sx={{ mb: 3 }}>
          <Grid container spacing={2} alignItems="stretch">
            <Grid item xs={12} md={6}>
              <Card sx={{ height: "100%" }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ display: "flex", alignItems: "center" }}>
                    <PersonIcon sx={{ mr: 1 }} /> Cliente
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="text.secondary">
                        Nombre:
                      </Typography>
                      <Typography variant="body1" fontWeight="medium">
                        {cuentaCorriente.entidadCompleta?.descripcion || "N/A"}{" "}
                        {cuentaCorriente.entidadCompleta?.apellido || ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="text.secondary">
                        DNI/CUIT/CUIL:
                      </Typography>
                      <Typography variant="body1" fontWeight="medium">
                        {cuentaCorriente.entidadCompleta?.dniCuitCuil || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="text.secondary">
                        Teléfono:
                      </Typography>
                      <Typography variant="body1" fontWeight="medium">
                        {cuentaCorriente.entidadCompleta?.telefono || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="text.secondary">
                        Email:
                      </Typography>
                      <Typography variant="body1" fontWeight="medium">
                        {cuentaCorriente.entidadCompleta?.email || "N/A"}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card sx={{ height: "100%" }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ display: "flex", alignItems: "center" }}>
                    <AccountBalanceWalletIcon sx={{ mr: 1 }} /> Paquete
                    {/* 🆕 Indicador de pasajero liberado */}
                    {cuotasInfo.liberado && (
                      <Chip
                        label="LIBERADO"
                        size="small"
                        color="success"
                        sx={{ ml: 1, fontWeight: "bold" }}
                      />
                    )}
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Grid container spacing={2}>
                    {cuotasInfo.item && (
                      <Grid item xs={12} md={6}>
                        <Typography 
                          variant="body1" 
                          fontWeight="bold" 
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <GroupIcon sx={{ fontSize: "1.5rem" }} />
                          Grupo: {cuotasInfo.item.descripcion}
                        </Typography>
                      </Grid>
                    )}
                    {cuotasInfo.ubicacion && (
                      <Grid item xs={12} md={6}>
                        <Typography 
                          variant="body1" 
                          fontWeight="bold" 
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <LocationOnIcon sx={{ fontSize: "1.5rem" }} />
                          Destino: {cuotasInfo.ubicacion.descripcion}
                        </Typography>
                      </Grid>
                    )}
                    <Grid item xs={6}>
                      <Typography variant="body2" color="text.secondary">
                        Saldo a pagar:
                      </Typography>
                      <Chip
                        icon={saldoChipIcon}
                        label={cuotasInfo.liberado ? "Sin costo" : formatCurrency(saldoPendiente)}
                        size="small"
                        sx={{
                          mt: 0.5,
                          bgcolor: saldoChipBg,
                          color: saldoChipColor,
                          fontWeight: "bold",
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="text.secondary">
                        Total cuotas pagadas:
                      </Typography>
                      <Typography variant="body1" fontWeight="medium" color={theme.palette.success.main}>
                        {formatCurrency(totalCuotasPagadas)}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Tabs
            value={tabActivaDetalle}
            onChange={(_event, value) => setTabActivaDetalle(value)}
            sx={{ borderBottom: 1, borderColor: "divider" }}
          >
            <Tab value="cuotas" label="Cuotas" />
            <Tab value="historial" label="Historial" />
          </Tabs>
        </Box>

        {/* Contenido tabs detalle */}
        <Box sx={{ mt: 2 }}>
          {tabActivaDetalle === "cuotas" ? (
            loadingCuotas ? (
              <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
                <CircularProgress />
              </Box>
            ) : cuotasInfo.liberado ? (
              /* 🆕 MENSAJE ESPECIAL PARA PASAJEROS LIBERADOS */
              <Box sx={{ textAlign: "center", p: 6 }}>
                <CheckCircleIcon
                  sx={{ fontSize: 100, color: "success.main", mb: 3 }}
                />
                <Typography variant="h4" gutterBottom fontWeight="bold" color="success.main">
                  Pasajero Liberado
                </Typography>
                <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
                  Este pasajero está liberado y no tiene cuotas que pagar
                </Typography>
                {cuotasInfo.item && cuotasInfo.ubicacion && (
                  <Paper sx={{ p: 3, maxWidth: 500, mx: "auto", bgcolor: alpha(theme.palette.success.main, 0.05) }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant="body2" color="text.secondary">
                          Paquete:
                        </Typography>
                        <Typography variant="body1" fontWeight="medium">
                          {cuotasInfo.item.descripcion}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body2" color="text.secondary">
                          Destino:
                        </Typography>
                        <Typography variant="body1" fontWeight="medium">
                          {cuotasInfo.ubicacion.descripcion}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Paper>
                )}
                <Chip
                  label="Sin costo"
                  color="success"
                  size="large"
                  sx={{ mt: 3, fontSize: "1rem", fontWeight: "bold" }}
                />
              </Box>
            ) : cuotasData.length === 0 ? (
              <Box sx={{ textAlign: "center", p: 4 }}>
                <Typography variant="h6" color="text.secondary">
                  No hay cuotas registradas para este cliente en este viaje
                </Typography>
                {cuotasInfo.item && cuotasInfo.ubicacion && (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    Paquete: {cuotasInfo.item.descripcion} - Destino: {cuotasInfo.ubicacion.descripcion}
                  </Typography>
                )}
              </Box>
            ) : (
              <>
                {/* Tabla de cuotas */}
                <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">ID Pago</TableCell>
                        <TableCell align="center">Cuota Nro</TableCell>
                        <TableCell>Fecha Pago</TableCell>
                        <TableCell>1er Vto</TableCell>
                        <TableCell>2do Vto</TableCell>
                        <TableCell align="right">Monto</TableCell>
                        <TableCell align="right">Descuento</TableCell>
                        <TableCell align="right">Interés</TableCell>
                        <TableCell align="right">Total</TableCell>
                        <TableCell align="right">Devolución</TableCell>
                        <TableCell align="center">Estado</TableCell>
                        <TableCell align="center">Acciones</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {cuotasData.map((cuota) => {
                        const montoDevolucion = Number(cuota.montoDevolucion || 0);
                        const estaPagada = cuota.idTransaccion !== null && montoDevolucion === 0;
                        const estaRevertida = cuota.idTransaccion !== null && montoDevolucion > 0;
                        const interesVisible = getInteresVisible(cuota)
                        const importeAPagar = getImporteAPagar(cuota)
                        const montoBaseBruto = Number(cuota?.montoBase ?? cuota?.monto ?? 0) || 0
                        const montoDescuento = Number(cuota?.montoDescuento ?? 0) || 0
                        const montoBaseNeto = Math.max(0, montoBaseBruto - montoDescuento)
                        const totalCalculado = montoBaseNeto + (interesVisible || 0)
                        const importeMostrar = estaPagada ? (Number(cuota.montoPagado) || totalCalculado) : totalCalculado
                        return (
                          <TableRow
                            key={cuota.cuotaNro}
                            sx={{
                              backgroundColor: estaPagada
                                ? alpha(theme.palette.success.main, 0.05)
                                : estaRevertida
                                ? alpha(theme.palette.error.main, 0.05)
                                : alpha(theme.palette.warning.main, 0.05),
                              "&:hover": {
                                backgroundColor: estaPagada
                                  ? alpha(theme.palette.success.main, 0.1)
                                  : estaRevertida
                                  ? alpha(theme.palette.error.main, 0.1)
                                  : alpha(theme.palette.warning.main, 0.1),
                              },
                            }}
                          >
                            <TableCell align="center">
                              {estaPagada ? (
                                <Typography variant="body2">{cuota.idPago ?? cuota.idTransaccion}</Typography>
                              ) : (
                                <Typography variant="body2" color="text.secondary">-</Typography>
                              )}
                            </TableCell>
                            <TableCell align="center">
                              <Chip
                                label={`Cuota ${cuota.cuotaNro}`}
                                size="small"
                                color={estaPagada ? "success" : "warning"}
                                variant="outlined"
                              />
                            </TableCell>
                            <TableCell>
                              {cuota.transaccion?.fecha ? (
                                formatDate(cuota.transaccion.fecha)
                              ) : (
                                <Typography variant="body2" color="text.secondary">
                                  Pendiente
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell>{formatDate(cuota.fechaPrimerVto)}</TableCell>
                            <TableCell>{formatDate(cuota.fechaSegundoVto)}</TableCell>
                            <TableCell align="right">
                              <Typography variant="body2" fontWeight="medium">
                                {formatCurrency(montoBaseBruto)}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              {montoDescuento > 0 ? (
                                <Typography variant="body2" color={theme.palette.error.main}>
                                  {formatCurrency(montoDescuento)}
                                </Typography>
                              ) : (
                                <Typography variant="body2" color="text.secondary">-</Typography>
                              )}
                            </TableCell>
                            <TableCell align="right">
                              {interesVisible ? (
                                <Typography variant="body2" color={theme.palette.error.main}>
                                  {formatCurrency(interesVisible)}
                                </Typography>
                              ) : (
                                <Typography variant="body2" color="text.secondary">-</Typography>
                              )}
                            </TableCell>
                            <TableCell align="right">
                              <Typography variant="body2" fontWeight="bold" color={theme.palette.primary.main}>
                                {formatCurrency(importeMostrar)}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              {cuota.montoDevolucion && Number(cuota.montoDevolucion) > 0 ? (
                                <Typography variant="body2" fontWeight="medium" color={theme.palette.error.main}>
                                  {formatCurrency(Number(cuota.montoDevolucion))}
                                </Typography>
                              ) : (
                                <Typography variant="body2" color="text.secondary">-</Typography>
                              )}
                            </TableCell>
                            <TableCell align="center">
                              {estaPagada ? (
                                <Chip
                                  icon={<CheckCircleIcon />}
                                  label="Pagada"
                                  size="small"
                                  color="success"
                                />
                              ) : estaRevertida ? (
                                <Chip
                                  icon={<UndoIcon />}
                                  label="Revertida"
                                  size="small"
                                  color="error"
                                />
                              ) : (
                                <Chip
                                  icon={<PendingIcon />}
                                  label="Pendiente"
                                  size="small"
                                  color="warning"
                                />
                              )}
                            </TableCell>
                            <TableCell align="center">
                              {!estaPagada && !estaRevertida ? (
                                <Button
                                  variant="contained"
                                  size="small"
                                  color="primary"
                                  startIcon={<PaymentIcon />}
                                  onClick={() => handleOpenPagoCuota({ ...cuota, importeAPagar })}
                                  disabled={cuentaCorriente?.paqueteCancelado === true}
                                  sx={{
                                    textTransform: "none",
                                    fontSize: "0.75rem",
                                  }}
                                >
                                  Pagar
                                </Button>
                              ) : estaRevertida ? (
                                <Box sx={{ display: "flex", gap: 0.5, justifyContent: "center" }}>
                                  <Tooltip title="Volver a pagar">
                                    <IconButton
                                      size="small"
                                      onClick={() => handleOpenPagoCuota({ ...cuota, importeAPagar, esRepago: true })}
                                      disabled={cuentaCorriente?.paqueteCancelado === true}
                                      sx={{
                                        color: theme.palette.success.main,
                                        "&:hover": {
                                          backgroundColor: alpha(theme.palette.success.main, 0.1),
                                        },
                                      }}
                                    >
                                      <AttachMoneyIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Recibo Devolución">
                                    <IconButton
                                      size="small"
                                      onClick={() => {
                                        const datosReversion = {
                                          montoRevertido: Number(cuota.montoDevolucion || 0),
                                          fechaPagoOriginal: cuota.transaccion?.fecha,
                                          fechaReversion: cuota.devolucionFecha || new Date(),
                                        }
                                        generateRefundReceiptPDF(cuota, datosReversion, cuentaCorriente, cuotasInfo, false, logoTenant, null, showFechaViajePdf)
                                      }}
                                      sx={{
                                        color: theme.palette.error.main,
                                        "&:hover": {
                                          backgroundColor: alpha(theme.palette.error.main, 0.1),
                                        },
                                      }}
                                    >
                                      <PictureAsPdfIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Historial de Pago">
                                    <IconButton
                                      size="small"
                                      onClick={() => handleDownloadTransaction(cuota.transaccion)}
                                      sx={{
                                        color: theme.palette.info.main,
                                        "&:hover": {
                                          backgroundColor: alpha(theme.palette.info.main, 0.1),
                                        },
                                      }}
                                    >
                                      <PictureAsPdfIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>

                                  <Tooltip title="Revertir Pago">
                                    <IconButton
                                      size="small"
                                      onClick={() => handleOpenRevertirPago(cuota)}
                                      sx={{
                                        color: theme.palette.error.main,
                                        "&:hover": {
                                          backgroundColor: alpha(theme.palette.error.main, 0.1),
                                        },
                                      }}
                                    >
                                      <UndoIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                              ) : (
                                <Box sx={{ display: "flex", gap: 0.5, justifyContent: "center" }}>
                                  <Tooltip title="Recibo">
                                    <IconButton
                                      size="small"
                                      onClick={() => generateReceiptPDF(cuota, cuota.transaccion, cuentaCorriente, cuotasInfo, false, logoTenant, null, showFechaViajePdf)}
                                      sx={{
                                        color: theme.palette.success.main,
                                        "&:hover": {
                                          backgroundColor: alpha(theme.palette.success.main, 0.1),
                                        },
                                      }}
                                    >
                                      <PictureAsPdfIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>

                                  <Tooltip title="Historial de Pago">
                                    <IconButton
                                      size="small"
                                      onClick={() => handleDownloadTransaction(cuota.transaccion)}
                                      sx={{
                                        color: theme.palette.info.main,
                                        "&:hover": {
                                          backgroundColor: alpha(theme.palette.info.main, 0.1),
                                        },
                                      }}
                                    >
                                      <PictureAsPdfIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>

                                  <Tooltip title="Revertir Pago">
                                    <IconButton
                                      size="small"
                                      onClick={() => handleOpenRevertirPago(cuota)}
                                      sx={{
                                        color: theme.palette.error.main,
                                        "&:hover": {
                                          backgroundColor: alpha(theme.palette.error.main, 0.1),
                                        },
                                      }}
                                    >
                                      <UndoIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                              )}
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Resumen de cuotas */}
                <Grid container spacing={2} sx={{ mt: 3 }}>
                  <Grid item xs={12} md={3}>
                    <Card>
                      <CardContent sx={{ textAlign: "center" }}>
                        <Typography variant="body2" color="text.secondary">
                          Total Cuotas
                        </Typography>
                        <Typography variant="h4" fontWeight="bold">
                          {cuotasData.length}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Card>
                      <CardContent sx={{ textAlign: "center" }}>
                        <Typography variant="body2" color="text.secondary">
                          Precio
                        </Typography>
                        <Typography variant="h5" fontWeight="bold" color={theme.palette.primary.main}>
                          {formatCurrency(cuentaCorriente?.precioOriginal ?? cuotasInfo.totalOriginal ?? cuotasInfo.total)}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Card>
                      <CardContent sx={{ textAlign: "center" }}>
                        <Typography variant="body2" color="text.secondary">
                          Pagadas
                        </Typography>
                        <Chip
                          icon={<CheckCircleIcon />}
                          label={cuotasInfo.pagadas}
                          color="success"
                          sx={{ fontSize: "1.2rem", fontWeight: "bold" }}
                        />
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Card>
                      <CardContent sx={{ textAlign: "center" }}>
                        <Typography variant="body2" color="text.secondary">
                          Pendientes
                        </Typography>
                        <Chip
                          icon={<PendingIcon />}
                          label={cuotasInfo.pendientes}
                          color="warning"
                          sx={{ fontSize: "1.2rem", fontWeight: "bold" }}
                        />
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </>
            )
          ) : loadingHistorial ? (
            <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Box>
              <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={generatingHistorialPdf ? <CircularProgress size={16} /> : <PictureAsPdfIcon />}
                  onClick={handleExportarHistorialPdfGeneral}
                  disabled={generatingHistorialPdf || !historialData.length}
                  sx={{
                    color: theme.palette.error.main,
                    borderColor: theme.palette.error.main,
                    "&:hover": {
                      borderColor: theme.palette.error.dark,
                      backgroundColor: alpha(theme.palette.error.main, 0.05),
                    },
                  }}
                >
                  PDF
                </Button>
              </Box>

              {historialData.length === 0 ? (
                <Box sx={{ textAlign: "center", p: 4 }}>
                  <Typography variant="h6" color="text.secondary">
                    No hay movimientos para este cliente/grupo/destino
                  </Typography>
                </Box>
              ) : (
                <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Fecha</TableCell>
                        <TableCell align="center">Tipo</TableCell>
                        <TableCell align="center">Nro Cuota</TableCell>
                        <TableCell>Descripción</TableCell>
                        <TableCell align="right">Monto</TableCell>
                        <TableCell align="center">Acciones</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {historialData.map((movimiento) => {
                        const esReversion = movimiento.tipo === "reversion"
                        return (
                          <TableRow key={movimiento.id}>
                            <TableCell>{formatDate(movimiento.fecha)}</TableCell>
                            <TableCell align="center">
                              <Chip
                                icon={esReversion ? <UndoIcon /> : <CheckCircleIcon />}
                                label={esReversion ? "Reversión" : "Pago"}
                                size="small"
                                color={esReversion ? "error" : "success"}
                                variant={esReversion ? "outlined" : "filled"}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <Chip label={`Cuota ${movimiento.cuotaNro}`} size="small" variant="outlined" />
                            </TableCell>
                            <TableCell>{movimiento.descripcion || "-"}</TableCell>
                            <TableCell align="right">
                              <Typography
                                variant="body2"
                                fontWeight="bold"
                                color={esReversion ? theme.palette.error.main : theme.palette.success.main}
                              >
                                {formatCurrency(Number(movimiento.monto || 0))}
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Tooltip title={esReversion ? "PDF devolución" : "PDF pago"}>
                                <IconButton
                                  size="small"
                                  onClick={() => handleDescargarPdfHistorial(movimiento)}
                                  sx={{
                                    color: esReversion ? theme.palette.error.main : theme.palette.success.main,
                                    "&:hover": {
                                      backgroundColor: alpha(
                                        esReversion ? theme.palette.error.main : theme.palette.success.main,
                                        0.1
                                      ),
                                    },
                                  }}
                                >
                                  <PictureAsPdfIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Box>
          )}
        </Box>
      </DialogContent>

      {/* Modal de pago de cuota */}
      <ModalMedioDePago
        open={abrirModalPagoCuota}
        handleClose={handleClosePagoCuota}
        precioTotal={cuotaSeleccionada?.importeAPagar ?? getImporteAPagar(cuotaSeleccionada) ?? 0}
        transaccionSeleccionada={cuotaSeleccionada}
        onConfirmarPago={handleConfirmarPagoCuota}
      />

      {/* Modal de confirmación de pago exitoso */}
      <ModalOpcionesFactura
        open={modalConfirmacionPagoOpen}
        handleClose={() => setModalConfirmacionPagoOpen(false)}
        transaccionData={{
          id: datosUltimoPago?.idTransaccion,
          fecha: new Date()
        }}
        impuestos={[]}
        itemsTransaccion={[]}
        entidadParaFactura={cuentaCorriente?.entidadCompleta || {}}
        usuarioParaFactura={user}
        tipoDeFactura={true}
        deDondeViene="pago"
        afipData={null}
        afipPayload={null}
        esReciboPago={true}
        datosRecibo={{
          cuota: datosUltimoPago?.cuota,
          cuentaCorriente: cuentaCorriente,
          cuotasInfo: cuotasInfo
        }}
      />

      {/* Modal de confirmación de reversión */}
      <Dialog
        open={modalConfirmacionRevertirOpen}
        onClose={handleCloseConfirmacionRevertir}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ bgcolor: theme.palette.error.main, color: "white", display: "flex", alignItems: "center", gap: 1 }}>
          <WarningIcon />
          Confirmar Reversión de Pago
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Typography variant="body1">
              ¿Está seguro que desea revertir el pago de la cuota #{cuotaARevertir?.cuotaNro}?
            </Typography>
            
            <Box sx={{ bgcolor: alpha(theme.palette.error.main, 0.1), p: 2, borderRadius: 1 }}>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Información de la cuota:
              </Typography>
              <Typography variant="body2">
                <strong>Número de cuota:</strong> {cuotaARevertir?.cuotaNro}
              </Typography>
              <Typography variant="body2">
                <strong>Monto pagado:</strong> {formatCurrency(cuotaARevertir?.montoPagado || cuotaARevertir?.monto || getMontoBaseNeto(cuotaARevertir) || 0)}
              </Typography>
              <Typography variant="body2">
                <strong>Fecha de pago:</strong> {cuotaARevertir?.transaccion?.fecha ? formatDate(cuotaARevertir.transaccion.fecha) : "N/A"}
              </Typography>
            </Box>

            <Box sx={{ bgcolor: alpha(theme.palette.warning.main, 0.1), p: 2, borderRadius: 1 }}>
              <Typography variant="body2" color="warning.main" fontWeight="bold">
                ⚠️ Esta acción cancelará el pago y la cuota volverá a estado pendiente
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <Box sx={{ p: 2, display: "flex", gap: 2, justifyContent: "flex-end" }}>
          <Button
            variant="outlined"
            onClick={handleCloseConfirmacionRevertir}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleConfirmarReversion}
            startIcon={<UndoIcon />}
          >
            Confirmar Reversión
          </Button>
        </Box>
      </Dialog>

      {/* Modal de medios de pago para reversión */}
      <ModalMedioDePago
        open={modalMediosDePagoRevertirOpen}
        handleClose={handleCloseModalMediosDePagoRevertir}
        precioTotal={cuotaARevertir?.montoPagado || cuotaARevertir?.monto || getMontoBaseNeto(cuotaARevertir) || 0}
        transaccionSeleccionada={null}
        onConfirmarPago={handleConfirmarReversionConMediosDePago}
        exigirTotalExacto={false}
        excluirCuentaCorriente={true}
        idUbicacionInicial={idUbicacionDefaultTransaccionCaja ? parseInt(idUbicacionDefaultTransaccionCaja) : null}
      />

      {/* Modal de reversión exitosa con opciones de PDF */}
      <ModalOpcionesFactura
        open={modalReversionExitosaOpen}
        handleClose={() => {
          setModalReversionExitosaOpen(false)
          setDatosReversion(null)
        }}
        transaccionData={{
          id: datosReversion?.idTransaccionRevertida,
          fecha: datosReversion?.fechaReversion || new Date(),
          monto: datosReversion?.montoRevertido || 0
        }}
        usuarioParaFactura={user}
        tipoDeFactura={true}
        deDondeViene="devolucion"
        afipData={null}
        afipPayload={null}
        esReciboDevolucion={true}
        datosDevolucion={{
          cuota: datosReversion?.cuota,
          datosReversion: datosReversion,
          cuentaCorriente: cuentaCorriente,
          cuotasInfo: cuotasInfo
        }}
      />
    </Dialog>
  )
}

export default ModalDetalleCuentaCorriente
